import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-mobile-device-security',
  templateUrl: './mobile-device-security.component.html',
  styleUrls: ['./mobile-device-security.component.css']
})
export class MobileDeviceSecurityComponent implements OnInit {

  heading = "Guard your Digital Privacy on Mobile Device";
  subheading = "Be responsible to safeguard your personal data & financial transactions";
  innerWidth:number = window.innerWidth;

  slides = [
    {img: "assets/images/mobile-device-security/text-1.webp",text:"AV Protection"},
    {img: "assets/images/mobile-device-security/text-2.webp",text:"Malicious App Protection"},
    {img: "assets/images/mobile-device-security/text-3.webp",text:"WiFi Monitoring"},
    {img: "assets/images/mobile-device-security/text-4.webp",text:"Web Security"},
    {img: "assets/images/mobile-device-security/text-5.webp",text:"Privacy Score"},
    {img: "assets/images/mobile-device-security/text-6.webp",text:"Breach Identification"},
    {img: "assets/images/mobile-device-security/text-7.webp",text:"Privacy Control"},
    {img: "assets/images/mobile-device-security/text-8.webp",text:"Mobile Device Booster"},
  ];
  slideConfig = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "dots":true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      // centerMode: true,

    }

  }, {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
      infinite: true,

    }
  },  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
    }
  }]};

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() {
  }

  breakpoint() {
  }

  afterChange() {
  }

  beforeChange() {
  }

  slides1 = [
    {img: "http://placehold.it/350x150/000000"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/000000"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/666666"}
  ];
  slide1Config = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "dots":true};

  addSlide1() {
    this.slides1.push({img: "http://placehold.it/350x150/777777"})
  }

  removeSlide1() {
    this.slides1.length = this.slides1.length - 1;
  }

  slick1Init() {
  }

  breakpoint1() {
  }

  afterChange1() {
  }

  beforeChange1() {
  }


  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {

    this.canonicalService.setCanonicalURL("https://www.protectt.ai/mobile-device-security");
    
   }

  ngOnInit(): void {
    this.titleService.setTitle('Best Mobile Device Security | Mobile Antivirus | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: "Antivirus Protection for all Mobile devices | Protectt.ai"});
    this.metaTagService.updateTag(
      { name: 'description', content: 'MProtectt makes it easy to secure mobile device from any privacy breach. It provides you 360 -degree security to your mobile device – Application, Device or Network based attacks. Download the most secure mobile security app now!'}
    );
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
